// extracted by mini-css-extract-plugin
export default {"transaction":"Transaction_transaction__Y2G3X","transaction_title":"Transaction_transaction_title__RiBJB"};